import { getTenantDir } from "@/plugins/env"

const getImgUrl = url => {
  const dir = getTenantDir()
  return require(`~/assets/images/${dir}/${url}`)
}

const getIconClass = icon => {
  const dir = getTenantDir()
  return `${dir}-${icon}`
}

const getIconColor = () => {
  const dir = getTenantDir()
  if (dir !== "mpj") {
    return "#E40032"
  } else {
    return "#2C5C32"
  }
}

export default function ({ app }, inject) {
  inject("webHelper", {
    getImgUrl,
    getIconClass,
    getIconColor
  })
}
